<template>
	<div>
		<buttonlist @help="help" @opentable="opentable" @exps="exps"  @search="search" @reflash="reflash" @export="exps" ref="SetBtn"></buttonlist>
		<!-- <el-card class="box-card">
			<div style="display: flex;background: white">
				<div style="width: 50%;text-align: left;display: flex">
					<el-button type="primary" size="mini"  @click="send">获取数据</el-button>
				</div>
			</div>
		</el-card> -->
		<div style="margin-top: 2px">
		<el-button type="primary" size="mini" @click="createBalance" :disabled="!btn.createBalance">{{$t('getapi[12458]')}}</el-button>
		</div>
        <wTable
                id="xpane-0"
                :data="dataSet"
                :loading="loading"
                queryData="BalanceInvInfoEx"
                :filter_thousandth="['init_qty','init_material_unit','init_man_unit','init_charge_unit','init_material_cost','init_man_cost','init_charge_cost',
                'receive_qty','receive_net_unit_price','rec_p_material_cost','diff_amount','rec_m_material_cost','rec_m_man_cost','rec_m_charge_cost',
                'rec_adjust_material_cost','rec_adjust_man_cost','rec_adjust_charge_cost','rec_m_ng_material_cost','rec_m_ng_man_cost','rec_m_ng_charge_cost',
                'issue_qty','issue_qty_adjust','issue_material_unit','issue_man_unit','issue_charge_unit','issue_material_cost','issue_man_cost',
                'issue_charge_cost','issue_adjust_material_cost','issue_adjust_man_cost','issue_adjust_charge_cost','remain_qty','remain_material_unit',
                'remain_man_unit','remain_charge_unit','remain_material_cost','remain_man_cost','remain_charge_cost']"
                :header="tableHeader"
                :option="tableOption"
                ref="singleTable"
                :checkflg="false"
        ></wTable>
        <!--<el-table
        :data="dataSet"
        v-loading="loading"
        :highlight-current-row="true"
        show-overflow-tooltip="true"
        border
        stripe
        size="mini"
        :height="tableHeight"
        :cell-style="cellStyle"
        header-row-class-name="headerclass"
        @selection-change="handleSelectionChange"
        style="width: 100%; margin-top:0px"
        >
<el-table-column show-overflow-tooltip prop="balance_year" :label="$t('getapi[1974]')"  fixed="left" align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="balance_month" :label="$t('getapi[1975]')"  fixed="left" align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"  fixed="left"></el-table-column>
<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')" fixed="left" ></el-table-column>
<el-table-column show-overflow-tooltip prop="part_master_unit" :label="$t('getapi[4590]')"  ></el-table-column>
<el-table-column show-overflow-tooltip prop="category_first_name" :label="$t('getapi[169]')"  ></el-table-column>
<el-table-column show-overflow-tooltip prop="category_second_name" :label="$t('getapi[170]')" ></el-table-column>
<el-table-column show-overflow-tooltip prop="category_third_name" :label="$t('getapi[171]')"  ></el-table-column>
<el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[3437]')"  ></el-table-column>
<el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"  ></el-table-column>
<el-table-column show-overflow-tooltip prop="part_model" :label="$t('getapi[124]')" ></el-table-column>
<el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[125]')"  ></el-table-column>
<el-table-column show-overflow-tooltip prop="init_qty" :label="$t('getapi[7299]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="init_material_unit" width="110px" :label="$t('getapi[7772]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="init_man_unit"  width="110px" :label="$t('getapi[7773]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="init_charge_unit"  width="110px" :label="$t('getapi[7774]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="init_material_cost"  width="110px" :label="$t('getapi[7775]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="init_man_cost"  width="110px" :label="$t('getapi[7776]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="init_charge_cost"  width="110px" :label="$t('getapi[7777]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="receive_qty" :label="$t('getapi[1850]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="receive_net_unit_price" :label="$t('getapi[4747]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="rec_p_material_cost"  width="110px" :label="$t('getapi[7779]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="diff_amount"  width="150px" :label="$t('getapi[7780]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="rec_m_material_cost"  width="150px" :label="$t('getapi[7781]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="rec_m_man_cost"  width="150px" :label="$t('getapi[7782]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="rec_m_charge_cost"  width="150px" :label="$t('getapi[7783]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="rec_adjust_material_cost"  width="150px" :label="$t('getapi[7784]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="rec_adjust_man_cost"  width="150px" :label="$t('getapi[7785]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="rec_adjust_charge_cost"  width="150px" :label="$t('getapi[7786]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="rec_m_ng_material_cost"  width="170px" :label="$t('getapi[7787]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="rec_m_ng_man_cost"  width="170px" :label="$t('getapi[7788]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="rec_m_ng_charge_cost"  width="170px" :label="$t('getapi[7789]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_qty" :label="$t('getapi[7317]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_qty_adjust" :label="$t('getapi[7318]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_material_unit"  width="110px" :label="$t('getapi[7319]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_man_unit" width="110px" :label="$t('getapi[7320]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_charge_unit" width="110px" :label="$t('getapi[7321]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_material_cost" width="110px" :label="$t('getapi[7322]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_man_cost" width="110px" :label="$t('getapi[7323]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_charge_cost" width="110px" :label="$t('getapi[7324]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_adjust_material_cost" width="150px" :label="$t('getapi[7325]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_adjust_man_cost" width="150px" :label="$t('getapi[7326]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="issue_adjust_charge_cost" width="150px" :label="$t('getapi[7327]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="remain_qty" :label="$t('getapi[7328]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="remain_material_unit" width="110px" :label="$t('getapi[7329]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="remain_man_unit" width="110px" :label="$t('getapi[7330]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="remain_charge_unit" width="110px" :label="$t('getapi[7331]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="remain_material_cost" width="110px" :label="$t('getapi[7332]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="remain_man_cost" width="110px" :label="$t('getapi[7333]')"  align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="remain_charge_cost" width="110px" :label="$t('getapi[7334]')"  align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" width="110px" :label="$t('getapi[143]')"></el-table-column>
        </el-table>   -->

        <!--show-overflow  省略号 <vxe-table
            :data="dataSet"
            v-loading="loading"
            border
            stripe
            resizable
            size="mini"
            :height="tableHeight"
        >

        <vxe-table-column show-overflow-tooltip field="part_code" :title="$t('getapi[112]')" width='100'/>
        <vxe-table-column show-overflow-tooltip field="part_version" :title="$t('getapi[149]')" width='100'/>
        <vxe-table-column show-overflow-tooltip field="part_master_unit" title="计量单位" />
        <vxe-table-column show-overflow field="part_name" title="物料名称" width='150' />

        <vxe-table-column show-overflow-tooltip field="vender_count" title="报价供应商数量" width='150' align="right"/>
        <vxe-table-column show-overflow-tooltip field="sum_net_unit" title="合计不含税单价" width='150' align="right"/>
        <vxe-table-column show-overflow-tooltip field="sum_unit" title="合计含税单价" width='150' align="right"/>
        <vxe-table-column show-overflow-tooltip field="avg_net_unit" title="平均不含税单价" width='150' align="right"/>
        <vxe-table-column show-overflow-tooltip field="avg_unit" title="平均含税单价" width='150' align="right"/> -->

        <!-- </vxe-table> -->
		<el-row class="page">
			<el-col :span="18">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[100, 200, 300, 400]"
					:page-size="pageSize"
					:pager-count="5"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<!-- </el-tabs> -->
		<serce :isVisible="isVisible" queryData="BalanceInvInfoEx" ref="ser" @getser="serclick"></serce>
		<ctable :isVisible="false" :title="$t('getapi[6664]')" queryData="BalanceInvInfoEx" tabNo="0" ref="ctab"
				@getctab="sortclick"></ctable>
		<!-- 改变表格顺序 -->
		<!-- <ctable :isVisible="false" title="CSV" queryData="SalLogicticscsvViewInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable> -->
		<selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/SchPro/GetPartPopupList'" @callback="getPart" ref="part"></selector>
		<el-dialog v-dialogDrag :visible.sync="visBalance" width="25%" :title="$t('getapi[12458]')" :close-on-click-modal="false" :modal-append-to-body="false">
			<table>
				<tr>
					<td style="width:60px">{{ $t('getapi[112]') }}</td>
					<td style="width:150px;">
						<routejump :urlNo="12">
						<el-input
								v-model="balanceDetail.part_code"
								type="text"
								readonly
								size="mini"
								style="width:100%"
						>
							<i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectPart()"></i>
						</el-input>
						</routejump>
					</td>
					<td style="width:60px">{{ $t('getapi[149]') }}</td>
					<td style="width:150px;">
						<el-input type="text" size="mini" v-model="balanceDetail.part_version"
								  :disabled="true"></el-input>
					</td>
				</tr>
			</table>

			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visBalance = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmCreateBalance" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'3_monthstockdetail',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
                maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			viewurl:'/CostCalc/InvView/GetSplitBalanceInventoryEx',
			expurl:'/CostCalc/InvView/GetSplitBalanceInventoryExToExecl',
			dialogVisible: false, //时间选择弹框
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('3_monthstockdetail'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			tableHeader: [],
			dataDetail: {
				Head: {},
				Lists: []
			}, // 编辑页面数据详情
			PlanTypeArray: [], // 计划类型数组
			isEdit: true, // 是否新增操作
			selectIDList: [],
			selectObj: {
				part_code: '',
				part_version: '',
				exclusively_id: 0,
				shelflife: ''
			},
			copyparam:{
				startMonth:'',
				copyMonth:'',
			},
			btn: {
				//拷贝
				send: false,
				print:false,
				//删除
				delete: false,
                createBalance:false,
			},
            visBalance: false,
			balanceDetail: {
                part_code: "",
                part_version: ""
			},
            scrollTop:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted: function() {
		let that = this;
        that.colsort();
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('BalanceInvInfoEx',0,PFileds=>{
			that.tableHeader=PFileds;		
		});	
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6664]"),this.$t("getapi[6633]"));
        },
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
			let limits=1;
			that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			console.log(that.$limits.authority('plv4', 218, 1))
            that.btn.createBalance = false
            if(that.$limits.authority('plv4', 218, 1) ==  1){
                that.btn.createBalance = true
            } else {
                that.btn.createBalance = false
            }
		},
		btnauthority() {
			let that = this;
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
		},
		closeAllRightButton(){
			let that =this;
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
		},
		changeperiod() {
			let that = this;
			that.$http.urlpost('/Inv/Manager/InvInfoUpdateShelflife', that.selectObj, function(res) {
				if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
					that.getView();
				}
				that.dialogVisible = false;
			});
		},
		showdialog() {
			let that = this;
			if (that.selectObj.exclusively_id == 0) {
				that.$message.warning(that.$t('getapi[8623]'));//'请选择一项！'
				return;
			}
			that.dialogVisible = true;
		},
		handleSelectionChange(val) {
		let that = this;
		that.selectIDList=val;
		if(that.selectIDList.length>0){
			that.btn.send = true;
			that.btn.delete = true;
			that.btn.print = true;
		}else{
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
		}
		},
		
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('3_monthstockdetail',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.pageIndex=1;
			that.$refs.ser.clearInput(that.isVisible, 'BalanceInvInfoEx');
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac
			};
			that.$http.urlpost(that.viewurl, data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
				}
				that.authority();
			});
		},
		// 根据ID获取详情数据
		editInfo(row) {
			let that = this;
			that.isShowEdit = true;
			that.isEdit = true;
			let parm = {
				Code: row.PO_Code,
				List: []
			};
			this.$refs.order.clearInput(this.isShowEdit, parm);
		},
		// 新增
		add() {
			let that = this;
			let datetime = Common.methods.getDatetime()
			that.isEdit = false;
			that.isShowEdit = true;
			that.dataDetail = {
				Head: {},
				Lists: []
			};
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		//按月拷贝成本
		copy(){
			let that = this;
			that.dialogVisible = true;
			
		},
		copyconfirm(){
			//  
			let that = this;
			that.btn.copy = false
			let parm = {
                "newmonth": that.copyparam.copyMonth.split("-")[1],
                "newyear": that.copyparam.copyMonth.split("-")[0],
                "oldmonth": that.copyparam.startMonth.split("-")[1],
                "oldyear": that.copyparam.startMonth.split("-")[0],
			}

			that.$http.urlpost('/Inv/PartCost/InvPartStdCostCopyCost', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
				that.btn.copy = true;
				that.dialogVisible = false;
			});


		},
		send(){
			let that = this;
			that.loading = true;
			that.$http.urlpost('/CostCalc/PurView/GetLatestPurPriceView', {}, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
				}
				that.loading = false;
			});
		},
		print(){
			let that = this;
			let parm = {
			po_no: '',
			TemplateName: '08Invoice_CSV.xlsx'
			};

			for(let i=0;i<that.selectIDList.length;i++){
			parm.po_no= parm.po_no + "'"+that.selectIDList[i].exclusively_id+"',";
			}
			parm.po_no =  parm.po_no.substring(0, parm.po_no.length - 1);

			that.btn.print = false;
			that.loading = true;
			that.$http.urlpost('/Print/CSVPrint', parm, function (res) {
			that.btn.print = true;
			if (res.Success == 1) {
			let hrefurl = res.Key;
			window.open(hrefurl);
			} 
			that.loading = false;
			});
		},
		deleteline(){
			let that = this;
			let parm = {
				Delivery_Note_N: that.selectIDList[0].Delivery_Note_N,
			};
			that.$http.urlpost('/Sal/Tru/DeleteCsv', parm, function(res) {
				if (res.Success == 1) {
					that.reflash();
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
				}
			});

		},
		// 导出
		exps() {
			/*let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac
			};
			that.$http.urlpost(that.expurl, data, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
				that.loading = false;
			});*/
            let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "BalanceInvInfoEx",
                fromname: that.$t('getapi[6664]'),
                SelectIndex: 0,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)
		},
		// 保存
		save() {
			let that = this;
			let parm = that.dataDetail;
			that.$http.urlpost('/Pur/Requisition/SaveData', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
			});
		},
		//
		editInfo1() {},
		editInfo2() {},
		cellStyle({row, column, rowIndex, columnIndex}) {
			console.log(column)
			if(columnIndex==12||columnIndex==19||columnIndex==32||columnIndex==43){
				return "background:rgb(128,255,128)"
			}else{
				return '';
			}
		},
        createBalance(){
            let that = this
			that.balanceDetail = {
                part_code: "",
                part_version: ""
			}
            that.visBalance = true
		},
        confirmCreateBalance(){
		    let that = this
			let parm = that.balanceDetail
            that.$http.urlpost('/Fin/BDiscItem/BalanceInventorCreate', parm, function (res) {
                if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    that.visBalance = false
                }
            });
		},
        selectPart(){
            let that = this;
            that.$refs.part.clearInput(true);
        },
        getPart(val){
            let that = this;
            that.balanceDetail.part_code = val.part_code
            that.balanceDetail.part_version = val.part_version
        },
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}

.bbl {
	margin: 0px auto 10px;
	white-space: pre;
	span {
		margin-left: 10px;
		min-width: 70px;
		text-align: left;
		line-height: 20px;
		display: inline-block;
		margin-right: 0px;
	}
}
</style>
